export enum webLogScreenName {
  travelscanner = "travelscanner",
}

export enum webLogPageCategory {
  title = "해외여행 스캐너",
}

export enum webLogEventName {
  travelscanner = "travelscanner",
  filter = "filter",
  filterReset = "filter_reset",
  notifyOn = "notify_on",
  notifyComplete = "notify_complete",
  popupLogin = "popup_login",
  viewDetail = "view_detail",
  viewCity = "view_city",
  viewFlight = "view_flight",
}

export enum webLogItemKind {
  button = "button",
  filter = "filter",
  popup = 'popup',
}
